import Modal from "../../../Framework/Components/Modals/Modal";
import React, {useEffect} from "react";
import {ButtonSubmit} from "../../../Framework/Components/Buttons/Button";
import {ColourMod} from "../../../Framework/Data/Enums/LayoutEnums";
import {startNewMessage, useMessageCentreDepartments} from "../../../Api/MessageCentreEndpoints";
import {MessageDepartmentType} from "../../../Types/Response/MessageCentre/MessageCentre";
import Select from "../../../Framework/Components/Forms/Select/Select";
import {PaginatedResponseType} from "../../../Types/Response/PaginatedResponseType";
import {useForm} from "react-hook-form";
import {FormWrapperLabel} from "../../../Framework/Components/Forms/FormEntryWrapper/FormEntryWrapper";
import {noDefaultSelect} from "../../ValidationRules";
import {useNavigate} from "react-router-dom";
import {useQueryClient} from "@tanstack/react-query";
import {ModalType} from "../../../Framework/Types/ModalTypes";

const CreateNewMessageModal = (props: ModalType) => {
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    const  {
        data,
    } : {
        status: any,
        data: PaginatedResponseType | undefined,
        error: any,
        isFetching: any
    } = useMessageCentreDepartments();

    const {
        register,
        handleSubmit,
        getValues,
        reset,
        formState: { errors },
    } = useForm({
        defaultValues: {
            subject: '',
            departmentId: '',
            text: '',
           // attachment: null,
            containsHtml: false
        },
        mode: "onChange"
    });

    const HandleCreate = (data: any) => {
        startNewMessage(data).then((r: any) => {
            if(r.data) {
                navigate(`/message-centre/${r.data.id}`);

                queryClient.invalidateQueries(['messageCentre']).then(r => null);

                if(props.closeCallback) {
                    props.closeCallback()
                }
            }
        });
    }

    useEffect(() => {
        reset()
    }, [props.visible]);

    return (
        <Modal title={'New Message'} isOpen={props.visible} closeCallback={props.closeCallback}>

            <form onSubmit={handleSubmit(HandleCreate)}>
                <fieldset className={'flex-column flex-gap-md'}>
                    <FormWrapperLabel
                        label={'Department'}
                        value={getValues().departmentId}
                        invalid={errors.departmentId && errors.departmentId?.message !== ''}
                        validationMessage={errors.departmentId?.message as string}
                    >
                        <Select
                            {...register('departmentId', { required: true, validate: () => noDefaultSelect(getValues().departmentId, 'Department is Required') })}
                            name='departmentId'
                            aria-invalid={errors.departmentId ? 'true' : 'false'}
                            placeholder={'Select Department...'}
                        >
                            {data?.data.map((department: MessageDepartmentType, index: number) => <option key={`department-option-=${index}`} value={department.id}>{department.name}</option>)}
                        </Select>
                    </FormWrapperLabel>

                    <FormWrapperLabel
                        label={'Message'}
                        value={getValues().text}
                        invalid={errors.text && errors.text?.message !== ''}
                        validationMessage={errors.text?.message as string}
                    >
                        <textarea rows={10} aria-invalid={errors.text ? 'true' : 'false'} {...register('text', { required: "This is a required field", minLength: { value: 2, message: 'Too short'}, maxLength: 10 })}>
                        </textarea>
                    </FormWrapperLabel>

                    <ButtonSubmit title={'Continue'} colour={ColourMod.Primary} fullWidth={true} raised={true} />
                </fieldset>
            </form>
        </Modal>
    )
}

export default CreateNewMessageModal